import { render, staticRenderFns } from "./AncillaryReissueSearchLegBodyCardDetails.vue?vue&type=template&id=1e997ec4&scoped=true"
import script from "./AncillaryReissueSearchLegBodyCardDetails.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBodyCardDetails.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBodyCardDetails.vue?vue&type=style&index=0&id=1e997ec4&prod&lang=scss&scoped=true"
import style1 from "./AncillaryReissueSearchLegBodyCardDetails.vue?vue&type=style&index=1&id=1e997ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e997ec4",
  null
  
)

export default component.exports